import React from "react";
import { Link } from "react-router-dom";
import PDFIcon from "../../Images/pdfIcon.png";

const PreIssueAdvertisment = () => {
  const certificates = [
    {
      link: "Essex BS Mum ENg Pg 1",
      title: "Essex-BS-Mum-ENg-Pg-1.pdf",
    },
    {
      link: "Sukhabar",
      title: "Sukhabar.pdf",
    },
    {
      link: "ESSEX BS Delhi Hindi",
      title: "ESSEX-BS-Delhi-Hindi.pdf",
    },
    {
      link: "ESSEX BS Delhi Eng Pg",
      title: "ESSEX-BS-Delhi-Eng-Pg.pdf",
    },
  ];

  const downloadFile = (event, status) => {
    event.preventDefault();

    if (status) {
      const formattedUrl = `https://essexmpl.com/Pdf/${status}`;
      window.open(formattedUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="py-80">
      <div className="container">
        <div className="row">
          {certificates.map((certificate, id) => (
            <div className="col-md-6 col-lg-3" key={id}>
              <div className="team-item">
                <Link
                  to={"#"}
                  onClick={(e) => downloadFile(e, certificate.title)}
                  target="_blank"
                >
                  <img src={PDFIcon} alt="thumb" />
                  <div className="team-content">
                    <div className="team-bio">
                      <h5>
                        <a href="team.html">{certificate.link}</a>
                      </h5>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PreIssueAdvertisment;
